import React from "react";
import { IPageSection } from "./IPageSection";
//@ts-ignore
import styles from "./page-section.module.css";

export const PageSection: React.FunctionComponent<{
  section: IPageSection;
  index: any;
}> = ({ section, index }) => {
  console.log({ 
    section, 
    index, 
    html: section.textContent.childMarkdownRemark.html,
    isDesktop: section.isDesktop
  });
  // if(section.isDesktop) return <div>Desktop section</div>
  return (
    <section className={styles.pageSection} id={`page_section_${index}`}>
      <div className={(index%2) ? styles.container : styles.containerReverse}>
        <div className={styles.imgBox} style={{maxWidth: section.isDesktop ? "50%" : "40%"}}>
          <img 
            src={section.sectionImages?.[0].file.url} 
            style={{width: section.isDesktop ? "100%" : "70%"}} 
          />
        </div>
        <div className={styles.textArea}>
          <h3>{section.titleText}</h3>
          <div 
            className={styles.innerText}
            dangerouslySetInnerHTML={{
              __html: section.textContent.childMarkdownRemark.html
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};
